import React, { useCallback, useEffect, useState, useRef } from 'react';
interface ImageCompareSliderProps {
  leftImage: string;
  rightImage: string;
  leftAlt?: string;
  rightAlt?: string;
}
export function ImageCompareSlider({
  leftImage,
  rightImage,
  leftAlt = 'Left comparison',
  rightAlt = 'Right comparison'
}: ImageCompareSliderProps) {
  const [position, setPosition] = useState(50);
  const containerRef = useRef<HTMLDivElement>(null);
  const isDragging = useRef(false);
  const updatePosition = useCallback((clientX: number) => {
    const container = containerRef.current;
    if (!container) return;
    const rect = container.getBoundingClientRect();
    const x = clientX - rect.left;
    const percent = Math.max(0, Math.min(100, x / rect.width * 100));
    setPosition(percent);
  }, []);
  const handlePointerDown = useCallback((e: React.PointerEvent) => {
    isDragging.current = true;
    (e.target as HTMLElement).setPointerCapture(e.pointerId);
    updatePosition(e.clientX);
  }, [updatePosition]);
  const handlePointerMove = useCallback((e: React.PointerEvent) => {
    if (!isDragging.current) return;
    updatePosition(e.clientX);
  }, [updatePosition]);
  const handlePointerUp = useCallback(() => {
    isDragging.current = false;
  }, []);
  return <div ref={containerRef} className="relative w-full rounded-2xl overflow-hidden select-none touch-none" style={{
    aspectRatio: '21 / 9'
  }} onPointerDown={handlePointerDown} onPointerMove={handlePointerMove} onPointerUp={handlePointerUp} data-id="element-142">
      {/* Right image (base layer) */}
      <img src={rightImage} alt={rightAlt} className="absolute inset-0 w-full h-full object-cover pointer-events-none" draggable={false} data-id="element-143" />

      {/* Left image (overlay, clipped via clip-path) */}
      <img src={leftImage} alt={leftAlt} className="absolute inset-0 w-full h-full object-cover pointer-events-none" style={{
      clipPath: `inset(0 ${100 - position}% 0 0)`
    }} draggable={false} data-id="element-144" />

      {/* Divider line */}
      <div className="absolute top-0 bottom-0 w-px bg-white/80 pointer-events-none" style={{
      left: `${position}%`,
      transform: 'translateX(-0.5px)'
    }} data-id="element-145" />

      {/* Drag handle */}
      <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 z-10 cursor-grab active:cursor-grabbing" style={{
      left: `${position}%`
    }} data-id="element-146">
        <div className="w-10 h-10 rounded-full bg-[#346042] shadow-lg shadow-black/15 flex items-center justify-center gap-[3px]" data-id="element-147">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" data-id="element-148">
            <path d="M6 4.5L2 9L6 13.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-149" />
            <path d="M12 4.5L16 9L12 13.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-150" />
          </svg>
        </div>
      </div>
    </div>;
}